module.exports = __webpack_public_path__ + "img/TTL.bae0492f.svg";